import PropTypes from 'prop-types';
import getIn from 'immutable-less/transmute/getIn';
import memoize from 'transmute/memoize';
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AuthContext = /*#__PURE__*/createContext({
  portal: null,
  user: null,
  gates: null,
  hubHasWorkflowsAccess: null
});
AuthContext.displayName = 'AuthContext';
AuthContext.Provider.propTypes = {
  value: PropTypes.shape({
    portal: PropTypes.object,
    user: PropTypes.object,
    gates: PropTypes.arrayOf(PropTypes.string.isRequired),
    hubHasWorkflowsAccess: PropTypes.bool
  })
};
export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;
export const isUngated = memoize(gates => memoize(gate => gates.includes(gate)));
export const hasScope = memoize(scopes => memoize(scope => scopes.includes(scope)));
export const getLimit = memoize(limits => memoize(limit => {
  const limitValue = getIn([limit], limits);
  if (typeof limitValue === 'number' && limitValue >= 0) {
    return limitValue;
  }
  return Infinity;
}));
export function wireAuthConsumer(WrappedComponent) {
  return props => /*#__PURE__*/_jsx(AuthConsumer, {
    children: context => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      getLimit: getLimit(context.portal.limits),
      isUngated: isUngated(context.gates),
      hasScope: hasScope(context.user.scopes)
    }))
  });
}
export default AuthContext;